import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import template from './templates/SelectBox.html?raw';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// NOTE (JS2TS): original define() also listed dojo/dijit/dojox deps never referenced in code and not
// used via data-dojo-type (connect, array, Color, keys, dijit _WidgetBase/_TemplatedMixin/
// _WidgetsInTemplateMixin, registry, on, request/xhr, dojox Standby, mouse, dom-style) — dead, dropped.

class SelectBox extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    currentFocus: any = null;
    _multiSelectList: any = null;

    labelAttribute: any = null;
    valueAttribute: any = null;
    filterPath: any = null;
    searchParam: any = null; // name des Parameters im Filter ( => pit-Filter)
    requestUrlParameter: any = null; // parametername für Extraparameter, der vom Controller erwartet wird
    requestUrlParameterValue: any = null; // wert des Extraparameters
    mandatory = true; // für Färbung wenn leer
    readonly = false;

    blankOptionText: any = null;
    blankOptionValue = "-x-";
    blankOptionAvailable = false;

    __request: any = null;
    _options: any = [];

    entities: any = [];
    url: any = null;
    minLetterCount = 3;
    selectedEntity: any = null;
    selectedValue: any = null;
    limit = 10;
    dataformat = "pit"; // wird für Request und Response benötigt (pithelper)

    _adjustCurrentSelectionState(): void {

        if (this.selectedValue != null && this.selectedEntity == null) { // zb. wenn die Inputbox eine ID voreingestellt bekommen hat
            var value = this.selectedValue;

            for (var x = 0; x < this.entities.length; x++) {
                var e = this.entities[x];
                var entityValue = this.PitHelper.getEntityAttributeValue(e, this.valueAttribute);

                if (entityValue == value) {
                    this.set("value", e);
                    return;// nochmal zurück und die Kette normal durchlaufen ... boah is des unschön, aber es funktioniert
                }
            }
        }

        if (this.selectedEntity == null && this.mandatory == true) {
            domClass.add(this.input, ["w3-pale-red", "w3-border-red"]);
        } else {
            domClass.remove(this.input, ["w3-pale-red", "w3-border-red"]);
        }

        var entity = this.selectedEntity;

        for (var i = 0; i < this._options.length; i++) {
            var option = this._options[i];

            var optionValue = option.value;

            if (entity != null) {
                var value = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute);

                if (optionValue == value) {
                    //domAttr.set(option, "selected");
                    domClass.add(option, "selectbox-active");
                } else {
                    domClass.remove(option, "selectbox-active");
                }
            }
            else {
                domClass.remove(option, "selectbox-active");
            }
        }

    }

    _setReadonlyAttr(value: any): void {
        this.readonly = value;
        domAttr.set(this.input, "disabled", this.readonly);
    }

    _setMandatoryAttr(value: any): void {
        this.mandatory = value;
        this._adjustCurrentSelectionState();
    }

    //_setRequestUrlParameterAttr: function (value) {
    //    this.requestUrlParameter = value;
    //},

    //_setRequestUrlParameterValueAttr: function (value) {
    //    this.requestUrlParameterValue = value;
    //},

    _setDataFormatAttr(value: any): void {

        if (value != "pit" && value != "json") {
            value = "json";
        }

        this.PitHelper._structureFormat = value;

        this.dataformat = value;
    }

    _getValueAttr(bPlainValue?: any): any {

        if (bPlainValue === true) {
            return this.input.value;
        }

        return this.selectedEntity;
    }

    _setValueAttr(value: any, bSuppressChange?: any): void {

        //console.debug("select: set value", value, bSuppressChange);
        //if (bPlainValue === true) { // dann kommt nur ID oder was auch immer bei den options als Value verwendet wird!

        //}

        this.selectedEntity = value;
        this._adjustCurrentSelectionState();

        if (value == null && (this.blankOptionValue != value || this.blankOptionAvailable != true)) {
            this.input.value = null;
        }
        else {
            if (this.dataformat == "pit") {
                this.PitHelper._structureFormat = "pit";
            } else if (this.dataformat == "json") {
                this.PitHelper._structureFormat = "json";
            }

            this.input.value = this.PitHelper.getEntityAttributeValue(this.selectedEntity, this.valueAttribute);
            //console.log("selectbox setinput", this.PitHelper.getEntityAttributeValue(this.selectedEntity, this.valueAttribute), this.input.value, this.valueAttribute);

            if (bSuppressChange === true) {

            } else {
                this.emit("change", value);
            }
        }

        //console.log("selectbox _setValueAttr", value, bSuppressChange, this.input.value);
    }

    _onChange_input(evt: any): void {
        //console.log("selectbox _onChange_input", evt);

        this.assignEntityFromSelectedValue();
    }

    assignEntityFromSelectedValue(): void {
        var optionValue = this.input.value;

        if (optionValue == "null") {
            optionValue = null;
        }
        //console.log("assignEntityFromSelectedValue", optionValue, this.blankOptionValue);
        if (optionValue == this.blankOptionValue && this.blankOptionAvailable == true) {
            this.selectedValue = optionValue;
            this.set("value", optionValue);
            return;
        }

        if (this.entities != null) {
            for (var i = 0; i < this.entities.length; i++) {
                var entity = this.entities[i];

                var value = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute);
                this.selectedValue = value;

                if (optionValue == value) {
                    this.set("value", entity);
                    break;
                }
            }
        }

    }

    _loadListValues(presetValue?: any, bSuppressChange?: any): void {

        // nicht resetten, evtl wird ein Wert gesetzt und die möglichen Werte danach nachgeladen
        //

        //if (presetValue != null && typeof (presetValue) != "undefined") {
        //    this.set("value", presetValue, bSuppressChange);
        //}
        //else {
        this.selectedEntity = null;
        this.input.value = "";
        //}

        this._adjustCurrentSelectionState();


        var url;
        if (this.url == null) {

        } else {
            url = this.url;
        }


        if (this.__request != null) {
            //console.log("selectbox: request cancel");
            this.__request.cancel();
            this.__request = null;
        }

        this.StandbyStart();

        var requestParams: any = {};

        if (this.filterPath != null) {
            requestParams.filterPath = this.filterPath;
        }

        if (this.searchParam != null) {
            requestParams.searchParam = this.searchParam;
        }

        if (this.limit != null) {
            requestParams.limit = this.limit;
        }

        requestParams.labelAttribute = this.labelAttribute;

        // Extraparameter
        if (this.requestUrlParameter != null) {
            requestParams[this.requestUrlParameter] = this.requestUrlParameterValue;
        }

        var requestUrl = window.appRoot + url;

        //console.log("selectbox _loadListValues", requestUrl, requestParams, presetValue);

        this.__request = this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, "_onLoadListValuesResponse", presetValue, bSuppressChange),
            lang.hitch(this, "_onLoadListValuesError"),
            false // sync
        );
    }

    _onLoadListValuesResponse(presetValue: any, bSuppressChange: any, response: any): void { // responsecallback
        //console.log("selectbox _onLoadListValuesResponse - respone - preset - suppress", response, presetValue, bSuppressChange);
        this.__request = null;
        // ist entweder klassisches pit-Datarray oder json-Array aus API
        if (this.dataformat == "pit") {
            this.entities = response.EntityDataArray;
        } else if (this.dataformat == "json") {
            this.entities = response;
            if ((typeof (response) as any) == "text") { // Kompatibilität mit bisher doppelt stringifizierten JSON-Responses
                this.entities = JSON.parse(response as any);
            }
        }

        this._constructOptions();

        if (presetValue != null && typeof (presetValue) != "undefined") {
            (this.set as any)("value", presetValue, bSuppressChange);
        }

        this.StandbyStop();
    }

    _onLoadListValuesError(err: any): void { // errorCallback
        console.error("_onLoadListValuesError", err);
        this.__request = null;
        if (typeof (err) == "object") {
            alert(err.Message);
        } else {
            alert(err);
        }
        this.StandbyStop();
    }

    empty(bSuppressChange?: any): void {
        domAttr.set(this.input, "innerHTML", null);

        this._options = [];

        (this.set as any)("value", null, bSuppressChange);
    }

    _constructOptions(): void {
        domAttr.set(this.input, "innerHTML", null);

        this._options = [];
        //console.log("_constructOptions", this.blankOptionText)
        if (this.blankOptionText != null) {
            var option: any = domConstruct.create("option", { value: this.blankOptionValue, innerHTML: this.blankOptionText }, this.input);
            domClass.add(option, "selectbox-items");

            if (this.blankOptionAvailable == true) {

            } else {
                domAttr.set(option, "disabled", true);
            }
        }

        // aus den geladenen Daten die selects erstellen
        if (this.entities != null) {
            for (var i = 0; i < this.entities.length; i++) {
                var entity = this.entities[i];

                var value = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute);
                var label = this.PitHelper.getEntityAttributeValue(entity, this.labelAttribute);

                var option: any = domConstruct.create("option", { value: value, innerHTML: label }, this.input);
                domClass.add(option, "selectbox-items");

                this._options.push(option);
            }
        }

        //this.set("value";
        this._adjustCurrentSelectionState();
    }

    _setupEventListener(): void {

    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this._options = [];

        this._setupEventListener();
        //this._loadListValues();
        this._adjustCurrentSelectionState();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}
SelectBox.prototype.declaredClass = 'more.SelectBox';

export default mdsWidget(SelectBox);
